import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";

import Header, {NavLink,NavLinks,PrimaryLink,NavToggle,DesktopNavLinks} from "../headers/light"


import image2 from "../../images/image2.png";


const Heading = styled.h1`
  ${tw`text-3xl text-center mt-24 sm:text-3xl sm:mb-4 lg:text-5xl xl:text-6xl font-black text-gray-100 leading-snug  `}
  span {
    ${tw`inline-block mt-2`}
  }
`;

const LogoLink = styled(NavLink)`
  ${tw`flex items-center font-black border-b-0 text-2xl! ml-0!`}
  img {
    ${tw`w-10 mr-3`}
  }
`;
const StyledHeader = styled(Header)`
  ${tw`pt-4 max-w-none w-full   `}
  ${DesktopNavLinks} ${NavLink}, ${LogoLink} {
    ${tw`text-black font-semibold hover:border-gray-800 text-center  `}
  }
  ${NavToggle}.closed {
    ${tw`text-gray-100 hover:text-primary-500`}
  }
`;
const LogoImg = tw.img`w-8`;

const Container = styled.div`
   ${tw`relative -mx-8 -mt-8 bg-center bg-cover h-screen min-h-144`}
 background-image: url(${image2});
`;

const PrimaryAction = tw.div`text-sm sm:text-2xl sm:mt-4 sm:px-0 sm:py-0  sm:mb-12 text-center text-gray-100 `;

const HeroContainer = tw.div`relative px-6 sm:px-8 mx-auto h-full flex flex-col`;
const Content = tw.div`px-4 flex flex-1 flex-col justify-center items-center`;
const space=tw.br`mx-8`


export default function HeroSection() {
  const navLinks = [
    <NavLinks key={1}>
      <NavLink href="#home"  >Home</NavLink>
      <NavLink href="#about">About</NavLink>
      <NavLink href="#services">Services</NavLink>
      <NavLink href="#contactus">Contact</NavLink>
    </NavLinks>
    
  ];

  return (
    <AnimationRevealPage>
      <Container>
        <HeroContainer>
          <StyledHeader links={navLinks} />
          <Content>
              <Content>
          <Heading>
              Empowering Business with<br/>
              Innovative TechSolutions
          </Heading>
          
          
          <PrimaryAction>Aadi Info Solutions is a leading software company specializing in custom software development, cloud solutions, and <br />  IT consulting. We help businesses leverage technology to achieve their goals and stay ahead of the competition</PrimaryAction>
      <PrimaryLink href="#contactus" >Get Quote</PrimaryLink>
        </Content>
          </Content>
        </HeroContainer>
      </Container>
    </AnimationRevealPage>
  );
}
